import { render, staticRenderFns } from "./OfferThumbnail.html?vue&type=template&id=2cfd9cde&scoped=true&"
import script from "./OfferThumbnail.vue?vue&type=script&lang=js&"
export * from "./OfferThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./OfferThumbnail.scss?vue&type=style&index=0&id=2cfd9cde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd9cde",
  null
  
)

export default component.exports